export const USEQuery = 'ums';
